import { InfoIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { BannerWrapper } from './Banners.styles';

const ExecutivePhoneBanner = () => {
  return (
    <Box bg="background" data-testid="ExecutivePhoneBanner">
      <BannerWrapper backgroundColor="lightDanger">
        <InfoIcon width={16} height={16} />
        <Text size="normal">Call from executive phone.</Text>
      </BannerWrapper>
    </Box>
  );
};

export default ExecutivePhoneBanner;
